$('body').on('change', '.child select[name="school"]', function() {
    var $this = $(this);
    var child = $this.parents('.child');

    if($this.val() === 'other') {
        // show the other options
        child.find('li[data-school="other"]').each(function() {
            var school = $(this);
            school.removeClass('hidden');
            school.find('input').prop('disabled', false);
            if(school.find('input').attr('data-required')) {
                school.find('input').addClass('required');
            }
        });

        child.find('input[name="school_other_name"]').focus();
    } else {
        child.find('li[data-school="other"]').addClass('hidden');
        child.find('li[data-school="other"] input').removeClass('required');
        child.find('li[data-school="other"] input').prop('disabled', true);
    }
});

$('body').on('change', '.child [name="counseling"]', function() {
    var $this = $(this);
    var child = $this.parents('.child');

    if($this.val() == 'Yes') {
        child.find('[data-section="counseling"]').removeClass('hidden');
        child.find('[data-section="counseling"] input').each(function() {
            var input = $(this);
            input.prop('disabled', false);
            if(input.attr('data-required')) {
                input.addClass('required');
            }
        });

        return false;
    }

    child.find('[data-section="counseling"]').addClass('hidden');
    child.find('[data-section="counseling"] input').removeClass('required');
    child.find('[data-section="counseling"] input').prop('disabled', true);
    
    return false;
});


$('body').on('submit', '.add-child form', function() {
    var $this = $(this);
    var form = $this.parents('.add-child');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    form.find('.error').removeClass('error');
    form.find('.required').each(function () {
        var input = $(this);
        if (input.attr('type') === 'radio') {
            if (!form.find('input[name="' + input.attr('name') + '"]:checked').length) {
                error = true;
            }
        }

        if (input.attr('type') === 'checkbox') {
            if (!input.prop('checked')) {
                error = true;
            }
        }

        if (input.val() === '') {
            error = true;
            input.addClass('error');
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            var child = data.data;

            $this.find('.card-details input').each(function() {
                var input = $(this);
                input.attr('value', input.val());
            });

            $this.find('.card-details textarea').each(function() {
                var textarea = $(this);
                textarea.text(textarea.val());
            });

            $this.find('.card-details select').each(function() {
                var select = $(this);
                select.find('option:selected').attr('selected', 'selected');
            });

            var form = $this.find('.card-details').clone(true, true);
            var card = `<div class="card child" data-child="${child.child}">
                <header>
                    <h4>${child.full_name}</h4>
                </header>

                <div class="card-details padding" data-view="details">
                    <div class="child-info">
                        <div class="profile-image-small">
                            <figure>
                                <img src="images/${child.profile_image_image}" alt="profile">
                            </figure>
                        </div>

                        <ul class="details-list table">
                            <li><span>Name</span> <span class="highlight" data-input="full_name" data-color="white">${child.full_name}</span></li>
                            <li><span>Status</span> <span class="highlight" data-input="status" data-color="${child.status_color}">${child.status}</span></li>
                            <li><span>DOB</span> <span class="highlight" data-input="date_of_birth_parsed" data-color="white">${child.date_of_birth_parsed}</span></li>
                            <li><span>School</span> <span class="highlight" data-input="school_parsed" data-color="white">${child.school_parsed}</span></li>
                            <li><span>Notes</span> <span class="highlight" data-input="notes" data-color="white">${child.notes}</span></li>
                        </ul>
                    </div>
                </div>

                <footer data-view="details">
                    <a href="new-application/${child.child}">Start Application</a>
                    <a class="toggle-card-view" data-view="delete">Delete</a>
                    <a class="toggle-card-view" data-view="edit">Edit</a>
                </footer>

                <div class="edit-child">
                    <form action="children/${child.child}" method="post">
                        <div class="card-details padding" data-view="edit">
                            ${form.html()}
                        </div>          
            
                        <footer data-view="edit">
                            <a class="toggle-card-view" data-view="details">Cancel</a>
                            <input type="hidden" name="_method" value="PUT">
                            <input type="submit" value="Save">
                        </footer>
                    </form>
                </div>

                <div class="delete-child">
                    <form action="children/${child.child}" method="post">
                        <div class="card-details padding" data-view="delete">
                            <p class="notice-message centered">Are you sure you want to delete this child</p>
                        </div>

                        <footer data-view="delete">
                            <a class="toggle-card-view" data-view="details">Cancel</a>
                            <input type="hidden" name="_method" value="DELETE">
                            <input type="submit" value="Delete">
                        </footer>
                    </form>
                </div>
            </div>`;

            $this.parents('.card').before(card);

            $this.find('.card-details input').each(function() {
                var input = $(this);
                input.attr('value', input.val(''));
            });

            $this.find('.card-details textarea').each(function() {
                var textarea = $(this);
                textarea.text(textarea.val(''));
            });

            $this.find('.card-details select').each(function() {
                var select = $(this);
                select.val('');
            });
            updateProgress($this.find('.profile-pic-uploader'), 0, false);
            $this.find('.profile-pic-uploader img').attr('src', $this.find('.profile-pic-uploader img').attr('data-src'));

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('submit', '.edit-child form', function() {
    var $this = $(this);
    var form = $this.parents('.edit-child');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    form.find('.error').removeClass('error');
    form.find('.required').each(function() {
        var input = $(this);
        if (input.attr('type') === 'radio') {
            if (!form.find('input[name="' + input.attr('name') + '"]:checked').length) {
                error = true;
            }
        }

        if (input.attr('type') === 'checkbox') {
            if (!input.prop('checked')) {
                error = true;
            }
        }

        if (input.val() === '') {
            error = true;
            input.addClass('error');
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            var child = data.data;

            // update the child
            var card = $('.child[data-child="'+child.child+'"]');
            
            // update the image
            card.find('.profile-image-small img').attr('src', 'images/'+child.profile_image_image);

            // update the data
            card.find('[data-input="full_name"]').html(child.full_name);
            card.find('[data-input="email"]').html(child.email);
            card.find('[data-input="status"]').html(child.status);
            card.find('[data-input="status"]').attr('data-color', child.status_color);
            card.find('[data-input="date_of_birth_parsed"]').html(child.date_of_birth_parsed);
            card.find('[data-input="school_parsed"]').html(child.school_parsed);
            card.find('[data-input="notes"]').html(child.notes);

            // change the view
            toggleCardView(card, 'details');

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('submit', '.delete-child form', function() {
    var $this = $(this);
    var form = $this.parents('.edit-child');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    form.find('.error').removeClass('error');
    form.find('.required').each(function() {
        var input = $(this);
        if(input.val() === '') {
            error = true;
            input.addClass('error');
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            $('.child[data-child="'+data.data.child+'"]').remove();

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('submit', '.confirm-child form', function() {
    var $this = $(this);
    var form = $this.parents('.confirm-child');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    form.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            window.location.reload();
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});